export default function (options) {
  var original = options.collection;
  var filtered = new original.constructor();
  filtered.add(original.models);
  filtered.filterCriterion = options.filterCriterium || {};
  var applyFilter = function (filterCriterion, collection) {
    var collection = collection || original;
    var criterion = filterCriterion;
    var items = _.isEmpty(criterion) ? collection.models : collection.where(criterion);
    return items;
  };
  filtered.filter = function filter(filterCriterion) {
    if (_.find(_.values(filterCriterion), function (str) {
      return str.match(/all/);
    })) {
      // delete filtered.filterCriterion[ _.keys(filterCriterion)[0] ];
      return original;
    } else {
      _.extend(filtered.filterCriterion, filterCriterion);
    }
    var items = applyFilter(filtered.filterCriterion);
    filtered.reset(items);
  };
  return filtered;
}
;